<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close transfer>
			<template #default>
				<div ref="plan_edit_form"></div>
				<vxe-grid ref="plandetail" v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	const formjson = {
		title: '表单',
		rule: {
			"width": "800",
			"height": "600",
			"fApi": [],
			"rule": [
				{
					"type": "$input",
					"field": "name",
					"title": "计划名称",
					"value": null,
					"hidden": false,
					"props": {
						"readonly":false
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$input",
					"field": "mark",
					"title": "备注",
					"value": null,
					"hidden": false,
					"props": {
						"inputprops":{
							"type":"textarea"
						},
						"readonly":false
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$emun",
					"field": "enable",
					"title": "是否启用",
					"value": 5,
					"hidden": false,
					"props": {
						"name": "enable"
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				// {
				// 	"type": "$upload",
				// 	"field": "upload",
				// 	"title": "upload",
				// 	"value": null,
				// 	"hidden": false,
				// 	"props": {},
				// 	"validate": [{
				// 		"required": false,
				// 		"message": "必填项"
				// 	}]
				// }
			],
			"option": {
				"form": {
					"labelWidth": "80px",
					"hideRequiredAsterisk": false,
					"showMessage": false,
					"inlineMessage": false
				},
				"global": {
					"*": {
						"props": {
							"el": true,
							"size": "small",
							"disabled": false
						},
						"col": {
							"span": 24,
							"offset": 0
						}
					},
					"el-divider": {
						"wrap": {
							"show": false
						},
						"native": false,
						"col": {
							"span": 24,
							"offset": 0
						},
						"props": {
							"contentPosition": "left"
						}
					}
				},
				"submitBtn": false,
				"resetBtn": false
			}
		}
	}
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import listMixins from '@_system/components/base/mixins/list/list.js'
	export default {
		mixins: [listMixins, modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				modal_title: '编辑计划',
				modal_width:800,
				modal_height:600,
				taskList:[]
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			list_beforeCreateGrid(gridOptions) {
				this.$api.campaign.listtask().then((res) => {
					this.taskList = res.list
					gridOptions.height = 350
					gridOptions.toolbarConfig = {
						size: 'mini',
						perfect: false,
						buttons: [{
							name: '新增',
							status: 'primary',
							code: 'add'
						}],
						customConfig: {
							storage: true
						},
						custom: true,
						refresh: true,
						zoom: true,
						tools: []
					}
					gridOptions.columns = [
						// {
						// 	type: 'checkbox',
						// 	title: '#',
						// 	width: 50,
						// }, 
						{
							field: 'time',
							title: '执行时间',
							editRender: {
								name: '$datePicker',
								props: {
									componenttype:'time'
								},
								events: {
									
								}
							},
						}, 
						{
							field: 'day',
							title: '执行周期',
							editRender: {
								name: '$select',
								props: {
									multiple:true,
									selectoptions:[{
										label:'周一',
										value:1,
									},{
										label:'周二',
										value:2,
									},{
										label:'周三',
										value:3,
									},{
										label:'周四',
										value:4,
									},{
										label:'周五',
										value:5,
									},{
										label:'周六',
										value:6,
									},{
										label:'周日',
										value:7,
									}]
								},
								events: {
									
								}
							},
				
						}, 
						{
							field: 'task',
							title: '任务',
							editRender: {
								name: '$select',
								props: {
									multiple:true,
									selectoptions:this.taskList.map((_item)=>{
										return {
											label:_item.name,
											value:_item.id,
										}
									})
								},
								events: {
									
								}
							},
						},
						{
							title: '操作',
							fixed: "right",
							align: 'center',
							width: 65,
							slots: {
								default: ({row}) => {
									return [<el-button style="color:#F56C6C;" type = "text" size = "mini" onClick = {() => {this.delete(row)}}>删除</el-button>]
								}
							}
						}
					]
					gridOptions.formConfig = false
					gridOptions.editRules = {
						time: [{
							required: true
						}],
						day: [{
							required: true
						}],
						task: [{
							required: true
						}]
					}
				})
				
				
			},
			list() {
				return new Promise((resolve) => {
					if(this.data && this.data.config){
						resolve({
							list: this.data.config
						})
					}else{
						resolve()
					}

				})
			},
			modal_init(){
				this.sourceData = this.data
				let formData = JSON.parse(JSON.stringify(formjson))
				let rule = formData.rule.rule
				let option = formData.rule.option
				option.el = this.$refs.plan_edit_form
				this.fApi = this.$formCreate(rule, option)
				this.fApi.nextTick(() => {
					this.regestevent(rule)
					this.setFormData()		
				})
				this.$emit('show')
			},	
			regestevent(rule){
				rule.forEach((item) => {
					if (item.field) {
						let on = {}
						if (typeof this[item.field + 'Input'] === 'function') {
							on.input = this[item.field + 'Input']
						}
						if (typeof this[item.field + 'Change'] === 'function') {
							on.input = this[item.field + 'Change']
						}
						if (typeof this[item.field + 'Button'] === 'function') {
							on.inputButtonclick = this[item.field + 'Button']
						}				
						this.fApi.updateRule(item.field, {
							on: on
						})
					}				
				})
			},
			setFormData(){
				if(this.sourceData){
					let fields = this.fApi.fields()
					fields.forEach((item) => {
						this.fApi.setValue(item, this.sourceData[item])
					})
				}
			},
			getgrid(){
				return this.$refs.plandetail
			},
			add(){
				this.getgrid().insert({})
			},
			delete(row){
				this.getgrid().remove(row)
			},
			submit() {
				this.fApi.submit((formData) => {
					// console.log(submitData)
					this.getgrid().validate(true, (res) => {
						if (!res) {
							let submitData = JSON.parse(JSON.stringify(formData))
							this.submitDataFormater(submitData)
							submitData.config = this.getgrid().getTableData().visibleData.map((item) => {
								let obj = JSON.parse(JSON.stringify(item))
								delete(obj.id)
								delete(obj.parentid)
								delete(obj._X_ROW_CHILD)
								delete(obj._X_ROW_KEY)
								return obj // 只保留需要的字段
							})
							if(this.data.id){
								submitData.id = this.data.id
							}	

							//console.log(submitData)
							this.$api.campaign.editplan(submitData).then(()=>{
								this.$emit('success')
								this.$nextTick(() => {
									this.modal_cancel()
								})
							})
						} else {
							for (let i in res) {
								console.log(res[i][0].rule)
								let content = res[i][0].rule.$options.content
								let message = res[i][0].rule.$options.message
								if(content){
									this.$message.error(content)
								}else if(message){
									this.$message.error(message)
								}else{
									this.$message.error('缺少必填项：' + res[i][0].column.title)
								}
								
							}
						}
					})
				})
				//this.init()
			},
			submitDataFormater(formData) {
				for (let i in formData) {
					if (i.match(/^\$son/)) {
						for (let j in formData[i]) {
							formData[i][j].forEach((item) => {
								for (let k in item) {
									if (k.match(/.*time$/g)) {
										item[k] = item[k]/1000
									}
								}
							})
						}
					} else if (i.match(/.*time$/g)) {
						console.log(i)
						formData[i] = formData[i]/1000
					}
				}
			},
			reset() {
				//this.init()
			}
		},
		components: {
			
		}
	}
</script>